import { render, staticRenderFns } from "./PReport.vue?vue&type=template&id=0ab46549&scoped=true"
import script from "./PReport.vue?vue&type=script&lang=js"
export * from "./PReport.vue?vue&type=script&lang=js"
import style0 from "./PReport.vue?vue&type=style&index=0&id=0ab46549&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab46549",
  null
  
)

export default component.exports